module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAAAXNSR0IArs4c6QAAAJ5JREFUKFOl0jFqQlEQheHvBNyBZC1ZnhBQsDJFkhXYuoa0LsHOSlAQQ4ogBHPlCg8eEt8TMs0U55/hzLk3pZQhTvhMUnRUSikbDPCC1ySHW3yFm221r/CMRZLj9VAbbrQffGCEZZJq8VJ/wY32jTnGSdZ9cNWrtR2ml3tanruC+MJTH9xsnuD9357vSuOunLd4wAxvfS/4iF/s+/7GGXGlWTtvuvaLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/bofang.png
// module id = sUto
// module chunks = 1